import type {
  FormattedLimitItem,
  LimitValueType
} from '@library/types/memberResponsibleGaming';
import { ProgressBar } from '@library/components/progress/ProgressBar';
import { useCallback } from 'react';

export interface MemberResponsibleGamingRowProps {
  limitValueType: LimitValueType;
  memberLimit: FormattedLimitItem;
}

export const MemberResponsibleGamingRow = ({
  memberLimit,
  limitValueType
}: MemberResponsibleGamingRowProps) => {
  const {
    limitType,
    limitValue,
    periodType,
    progressPercent,
    progressValue,
    remainingValue,
    updatedDate,
    updatedTime
  } = memberLimit;

  // if remaining value <= 0, set value to 0
  const formattedRemainingValue = remainingValue <= 0 ? 0 : remainingValue;
  const isAmountValueType = limitValueType === 'Amount';

  const getDisplayValue = useCallback(
    (value: number) => {
      if (isAmountValueType) {
        return `$${(value / 100).toFixed(2)}`;
      }
      return value;
    },
    [isAmountValueType]
  );

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex h-16 cursor-pointer items-center border-b xl:text-xs"
      data-testid={`member-${periodType}-limit-${limitType}-${limitValueType}`}
    >
      {/* PERIOD */}
      <p className="flex flex-1 p-3">{periodType}</p>
      {/* LIMIT */}
      <p className="flex flex-1 p-3">{getDisplayValue(limitValue)}</p>
      {/* PROGRESS BAR */}
      <div className="flex flex-1 flex-row items-center gap-2 p-3">
        <ProgressBar className="w-28" value={progressPercent} />
        <p className="text-soClean-100">{getDisplayValue(progressValue)}</p>
      </div>
      {/* REMAINING */}
      <p className="flex flex-1 p-3">
        {getDisplayValue(formattedRemainingValue)}
      </p>
      {/* UPDATED AT */}
      <div className="flex flex-1 flex-col p-3">
        <p>{updatedDate}</p>
        <p>{updatedTime}</p>
      </div>
    </div>
  );
};
